<script>
import options from './SecondaryArticleSpots.options'
export default options
</script>

<template>
  <article class="kb-secondary-article-spots">
    <!-- hvis det er desktop eller laptop grid med secondary article cards-->
    <section
      class="kb-secondary-article-spots__grid-section kb-secondary-article-spots--hide-grid"
    >
      <div class="kb-secondary-article-spots__header">
        <div class="kb-secondary-article-spots__header-breaker">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 704 11"
          >
            <path stroke="#124999" d="M704 1H2c-.55228 0-1 .44772-1 1v9" />
          </svg>
        </div>
        <h4 class="kb-secondary-article-spots__header-title">
          {{ getLabel('title') }}
        </h4>
      </div>

      <div class="kb-secondary-article-spots__grid-container">
        <template v-for="(card, index) in contentJson">
          <SliderCardBasic :data="card" />
        </template>
      </div>
    </section>

    <!-- hvis der er tablet eller mobile - ContentCarousel med cards'ne -->

    <section
      class="kb-secondary-article-spots__slider kb-secondary-article-spots--hide-slider"
    >
      <div
        class="kb-secondary-article-spots__header kb-secondary-article-spots__slider-header"
      >
        <div
          class="kb-secondary-article-spots__header-breaker kb-secondary-article-spots__slider-header-breaker"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 704 11"
          >
            <path stroke="#124999" d="M704 1H2c-.55228 0-1 .44772-1 1v9" />
          </svg>
        </div>
        <h4
          class="kb-secondary-article-spots__header-title kb-secondary-article-spots__slider-header-title"
        >
          {{ getLabel('title') }}
        </h4>
      </div>

      <ContentCarousel
        :contentJson="contentJson"
        :link="link"
        :carouselId="carouselId"
      />
    </section>
  </article>
</template>
